import { render, staticRenderFns } from "./productGroudsAdd.vue?vue&type=template&id=7d886d40&scoped=true&"
import script from "./productGroudsAdd.vue?vue&type=script&lang=js&"
export * from "./productGroudsAdd.vue?vue&type=script&lang=js&"
import style0 from "./productGroudsAdd.vue?vue&type=style&index=0&id=7d886d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d886d40",
  null
  
)

export default component.exports